import { render, staticRenderFns } from "./FaceLiveEx.vue?vue&type=template&id=a0e51222&"
import script from "./FaceLiveEx.vue?vue&type=script&lang=js&"
export * from "./FaceLiveEx.vue?vue&type=script&lang=js&"
import style0 from "./FaceLiveEx.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FaceLiveEx.vue"
export default component.exports